// Firebase Configuration
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, enableIndexedDbPersistence } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyBX-FowjoJ-oefziFeY1HrbzHo9Q6ON6WY",
  authDomain: "grownupscal.firebaseapp.com",
  projectId: "grownupscal",
  storageBucket: "grownupscal.firebasestorage.app",
  messagingSenderId: "804443210244",
  appId: "1:804443210244:web:155c31e2dcddd48f89eb51",
  measurementId: "G-2S49KKHW8X"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const analytics = getAnalytics(app);

// Enable offline persistence for Firestore (GRO-32)
// This allows the app to work offline and sync when back online
enableIndexedDbPersistence(db).catch((err) => {
  if (err.code === 'failed-precondition') {
    // Multiple tabs open - persistence can only be enabled in one tab at a time
    console.warn('Firestore persistence unavailable: multiple tabs open');
  } else if (err.code === 'unimplemented') {
    // Browser doesn't support persistence
    console.warn('Firestore persistence unavailable: browser not supported');
  }
});

export default app;
